import { useState, useEffect, useRef, useContext } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { isMobile } from 'react-device-detect';
import { RenderScrollContext } from '../../contexts/RenderScrollContext';

const DocumentPage = ({ srcImage, index, form, lineRef, zoomStyles, children, isOnPreviewForm, onOrientationChange }) => {
  const [isHorizontal, setIsHorizontal] = useState(null);
  const { calculateWidthPercentageOfPage, zoomLevel } = useContext(RenderScrollContext);

  const wrapperRef = useRef(null);

  // Check if image is horizontal as a Promise
  const checkHorizontalImage = (srcImage) => {
    return new Promise((resolve) => {
      let im = new Image();
      im.src = srcImage;
      im.onload = () => {
        resolve(im.width > im.height);
      };
    });
  };

  useEffect(() => {
    checkHorizontalImage(srcImage).then((result) => {
      setIsHorizontal(result);
      if (typeof onOrientationChange === 'function') {
        onOrientationChange(result);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [srcImage]);

  useEffect(() => {
    const handleTouchMove = (event) => {
      if (wrapperRef.current && wrapperRef.current.contains(event.target)) {
        if (event.touches.length === 2) {
          event.preventDefault();
        } else {
          document.body.style.overflowY = "auto";
        }
      }
    };

    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  if (isHorizontal === null) {
    return <div></div>;
  }

  const imageElement = (
    <img
      ref={lineRef}
      alt="renderedImage"
      src={srcImage}
      className={`${form ? "pdf-images-on-preview" : "pdf-images"} ${isHorizontal ? "horizontal-page" : ""}`}
      id={`pdf-page-${index}`}
      style={{ ...zoomStyles, width: '100%', height: 'auto' }}
    />
  );

  const percentage = zoomLevel * calculateWidthPercentageOfPage(index);

  // max-width: 100% for mobile devices causes issues with positioning. Only set it if it's less than 100%
  return (
    <div ref={wrapperRef} className={form ? "page-image-on-preview" : "page-image"} style={{
      width: percentage === 100 ? '' : `${percentage}%`,
      display: 'block',
      margin: 'auto'
    }}>
      {isMobile && !isOnPreviewForm ? (
        <TransformWrapper
          pinch={{ disabled: false }}
          panning={{ disabled: true }}
          wheel={{ disabled: true }}
          doubleClick={{ disabled: true }}
          wrapStyle={{ pointerEvents: "none" }}
        >
          <TransformComponent>{imageElement}</TransformComponent>
        </TransformWrapper>
      ) : (
        imageElement
      )}
      {children}
    </div>
  );
};

export default DocumentPage;